exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboard-quiz__cont{padding-top:0}.largeIframe{position:absolute;left:0}.onboard-iframe{position:relative;max-width:900px;margin-right:auto;margin-left:auto}.onboard-iframe iframe{max-height:630px}", ""]);

// exports
